import { useServices } from '../../../services/useServices';
import { usePipelineQuery } from './usePipelineQuery';

export const useTimerStatuses = () => {
  const { pipelines } = useServices();

  return usePipelineQuery(
    ['pipelines', 'timers'],
    () => pipelines.getTimers()
  );
};
